var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.727,
    height: 23.696,
    viewBox: "0 0 24.727 23.696",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M24.662,9.449a1.313,1.313,0,0,0-1.13-.9L16.394,7.9l-2.821-6.6a1.315,1.315,0,0,0-2.418,0L8.334,7.9l-7.139.648a1.316,1.316,0,0,0-.747,2.3l5.4,4.731L4.253,22.585a1.314,1.314,0,0,0,1.956,1.421l6.155-3.68,6.154,3.68a1.315,1.315,0,0,0,1.957-1.421l-1.591-7.007,5.4-4.731A1.316,1.316,0,0,0,24.662,9.449Zm-12.18,10.8",
    transform: "translate(0 -0.496)",
    fill: "#feddbb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarEmpty);
export default __webpack_public_path__ + "static/media/star-empty.ae4ab388cbaf1cecf7931ec7307d76a9.svg";
export { ForwardRef as ReactComponent };